import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';

import { history } from './helpers';
import { strings } from './common/translations';
import Home from './home/Home';
import SectionAltaFormazione from './sections/alta-formazione/section-alta-formazione';
import SectionRicercaInnovazione from './sections/ricerca-innovazione/section-ricerca-innovazione';
import SectionRetiCollaborazione from './sections/reti-collaborazione/section-reti-collaborazione';
import SectionSPARQL from './sections/SectionSPARQL';

export const RouteApp = props => {

    return (   
        <Router history={history}>
            <Switch>
                <Route exact path={`/`} component={Home} />    
                <Route exact path={`/${strings.NAVIGATION.SECTION_1.URL}`} component={SectionAltaFormazione} />                  
                <Route exact path={`/${strings.NAVIGATION.SECTION_2.URL}`} component={SectionRicercaInnovazione} />                  
                <Route exact path={`/${strings.NAVIGATION.SECTION_3.URL}`} component={SectionRetiCollaborazione} />                 
                <Route exact path={`/${strings.NAVIGATION.SECTION_4.URL}`} component={SectionSPARQL} />                 
            </Switch>
        </Router>
    )        
}